import { useAppContext } from "../stores";
export const useBrandConfig = () => {
    const { state: { config }, } = useAppContext();
    return config?.brand;
};
//# sourceMappingURL=useBrandConfig.js.map